/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Carrier_Notices_Message_HelpInputs */

const en_carrier_notices_message_help = /** @type {(inputs: Carrier_Notices_Message_HelpInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Plain text only. Line breaks are preserved.`)
};

const es_carrier_notices_message_help = /** @type {(inputs: Carrier_Notices_Message_HelpInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Solo texto plano. Se conservan los saltos de linea.`)
};

/**
* | output |
* | --- |
* | "Plain text only. Line breaks are preserved." |
*
* @param {Carrier_Notices_Message_HelpInputs} inputs
* @param {{ locale?: "en" | "es" }} options
* @returns {LocalizedString}
*/
export const carrier_notices_message_help = /** @type {((inputs?: Carrier_Notices_Message_HelpInputs, options?: { locale?: "en" | "es" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Carrier_Notices_Message_HelpInputs, { locale?: "en" | "es" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_carrier_notices_message_help(inputs)
	return es_carrier_notices_message_help(inputs)
});